import * as React from "react";
const IconRdtResultMixed = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      d="M10.85 11.105c.238-.105.495-.131.743-.079s.485.185.677.39a1 1 0 0 0 1.46-1.368 3.3 3.3 0 0 0-1.722-.978 3.2 3.2 0 0 0-1.966.206 3.4 3.4 0 0 0-1.495 1.304A3.6 3.6 0 0 0 8 12.5c0 .678.188 1.346.547 1.92s.877 1.031 1.495 1.304a3.2 3.2 0 0 0 1.966.206 3.3 3.3 0 0 0 1.722-.978 1 1 0 1 0-1.46-1.368c-.192.205-.43.337-.677.39a1.2 1.2 0 0 1-.742-.079 1.4 1.4 0 0 1-.609-.537A1.6 1.6 0 0 1 10 12.5c0-.31.087-.61.242-.858.156-.248.37-.432.609-.537M40 24a2 2 0 1 0-4 0 2 2 0 0 0 4 0M32.5 25.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    />
    <path
      
      fillRule="evenodd"
      d="M11 21a3 3 0 1 0 0 6h15a3 3 0 1 0 0-6zm0 2h2v2h-2a1 1 0 1 1 0-2m11 2h-2v-2h2zm-7-2h3v2h-3zm9 2h2a1 1 0 1 0 0-2h-2z"
      clipRule="evenodd"
    />
    <path
      
      fillRule="evenodd"
      d="M11 31a7 7 0 1 1 0-14h26a7 7 0 1 1 0 14zm0-12h26a5 5 0 0 1 0 10H11a5 5 0 0 1 0-10M13 33a1 1 0 0 1 1-1h2.5a2.5 2.5 0 0 1 0 5H15v1a1 1 0 1 1-2 0zm2 2h1.5a.5.5 0 0 0 0-1H15zM28 9a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h1.5a2.5 2.5 0 0 0 0-5zm2.5 3H29v-1h1.5a.5.5 0 0 1 0 1"
      clipRule="evenodd"
    />
    <path
      
      d="M22.5 39a1 1 0 0 0 .936-.649l1.5-4a1 1 0 1 0-1.872-.702l-.564 1.503-.564-1.503a1 1 0 0 0-1.872.702l1.5 4A1 1 0 0 0 22.5 39M35 16a1 1 0 0 0 1-1v-2a1 1 0 0 0 0-2 1 1 0 0 0 0-2c-.726 0-1.276.325-1.611.79A2.1 2.1 0 0 0 34 11a1 1 0 1 0 0 2v2a1 1 0 0 0 1 1"
    />
  </svg>
);
export default IconRdtResultMixed;
